<header class="app-header">
  <h1 class="font-2xl">
    @if (imageUrl) {
      <pre>{{ imageUrl }}</pre>
    }
    <ng-content select="block-start"></ng-content>
  </h1>
  <ng-content select="block-end"></ng-content>
</header>
